import ambiente from "./ambiente";
import UserInfo from "./UserInfo";

export const navigation = [
  {
    text: "Cadastros",
    icon: "plus",
    items: [
      {
        text: "Contribuintes",
        path: "/contribuintes",
      },
      {
        text: "CPBS",
        path: "/cpbs",
      },
      {
        text: "Imóveis",
        path: "/imoveis",
      },
      {
        text: "Imóvel BCI",
        path: "/imovel-bci",
      },
      {
        text: "Veículos",
        path: "/veiculos",
      },
      {
        text: "Permissionários",
        path: "/permissionarios",
      },
      {
        text: "Unificar Cadastros",
        path: "/unificacaocadastros",
      },
      {
        text: "ISS",
        items: [
          {
            text: "NFSE",
            path: "/nfse",
          },
          {
            text: "Categoria de Serviços",
            path: "/categorias_servicos",
          },
          {
            text: "Serviços de ISS",
            path: "/servicosiss",
          },
          {
            text: "Categoria de CPBS",
            path: "/categorias_cpbs",
          },
          {
            text: "Situações Cadastrais",
            path: "/situacoes_cpbs",
          },
          {
            text: "Regimes Tributários",
            path: "/regimes_cpbs",
          },
          {
            text: "Tipos de Recolhimento",
            path: "/tipos_recolhimento_iss",
          },
          {
            text: "Graus de Instrução",
            path: "/graus_instrucao",
          },
          {
            text: "Naturezas Jurídicas",
            path: "/naturezas_juridicas",
          },
          {
            text: "CNAE",
            path: "/cnaeprefeitura",
          },
          {
            text: "LCP 116",
            path: "/lcp116prefeitura",
          },
          {
            text: "Categoria LCP 116",
            path: "/categorialcp116prefeitura",
          },
        ],
      },
      {
        text: "IPTU",
        items: [
          {
            text: "Segmentos",
            path: "/segmentos",
          },
          {
            text: "Logradouros",
            path: "/logradouros",
          },
          {
            text: "Bairros",
            path: "/bairros",
          },
          {
            text: "Distritos",
            path: "/distritos",
          },
          {
            text: "Loteamentos",
            path: "/loteamentos",
          },
         
          {
            text: "Alíquotas",
            path: "/aliquotas_iptu",
          },
          {
            text: "(p) Valor m²",
            path: "/aliquotas_iptu",
            visible: false,
          },
          {
            text: "(p) Simulação de Lançamento",
            path: "/cubo_imoveis",
            visible: false,
          },
          {
            text: "(p) Arquivo Gráfica",
            path: "/cubo_imoveis",
            visible: false,
          },
        ],
      },
      {
        text: "Outros",
        items: [
          {
            text: "Retenções Externas",
            path: "/retencoesexternas",
          },
          {
            text: "Contadores",
            path: "/contadores",
          },
          {
            text: "Colaboradores",
            path: "/colaboradores",
          },
          {
            text: "Indices de Preços",
            path: "/indiceprecos",
          },
          {
            text: "Responsáveis Técnicos",
            path: "/responsaveistecnicos",
          },
          {
            text: "Criar Processamento",
            path: "/criar_processamento",
            visible: UserInfo.possuiPerfil(["trimap"]),
          },
        ],
      },
      
      
    ],
  },
  {
    text: "Movimentos",
    icon: "chart",
    items: [
      {
        text: "Lista de DAM's",
        path: "/dams",
      },
      {
        text: "Lista de Alvarás",
        path: "/alvaras",
      },
      {
        text: "Lista de CEF´s",
        path: "/cefs",
        visible: false,
      },
      {
        text: "Lista de NFSe",
        path: "/nfse_grade",
        visible: false,
      },
      {
        text: "Alvará Funcionamento",
        path: "/alvara_funcionamento/",
      },
      {
        text: "Alvará Veículos",
        path: "/alvara_veiculo",
      },
      {
        text: "Alvará Sanitário",
        path: "/alvara_sanitario/",
      },

      {
        text: "Alvará Horário Especial",
        path: "/alvara_horario_especial",
      },
      {
        text: "Alvará de Publicidade",
        path: "/alvara_publicidade",
      },
      {
        text: "Alvará Uso Log. Público",
        path: "/alvara_logradouro_publico",
      },
      {
        text: "Alvarás Diversos",
        path: "/alvara_diversos",
      },
      {
        text: "Alvará de Construção",
        path: "/alvara_construcao",
      },
      {
        text: "Habite-se",
        path: "/habitese",
      },
      {
        text: "ITBI",
        path: "/itbi",
      },
      {
        text: "Nota Fiscal Avulsa",
        path: "/nfavulsa",
      },
      {
        text: "Lançamentos Diversos",
        path: "/lancamentotaxas",
      },

      {
        text: "Certidão Negativa",
        path: "/certidaonegativa",
      },

      {
        text: "Baixa Manual",
        path: "/baixa_manual",
      },
      {
        text: "(p) Alterar Contribuinte IPTU",
        path: "/arrecadacoes",
        visible: false,
      },
      {
        text: "(p) Isenção",
        path: "/arrecadacoes",
        visible: false,
      },
      {
        text: "(p) Transf. ITBI",
        path: "/arrecadacoes",
        visible: false,
      },
      {
        text: "Lançamento de IPTU",
        path: "/lancamentoiptu",
      },
      {
        text: "Gerar Permissionários",
        path: "/faturamento_permissionarios",
      },
      {
        text: "Processamento de Arquivos",
        path: "/processar_arquivo",
      },

      // {
      //   text: 'Relatorios',
      //   path: '/relatorios'
      // },
      // {
      //   text: 'Arrecadações',
      //   path: '/arrecadacoes'
      // },
      // {
      //   text: 'Imóveis Inativos',
      //   path: '/imovel_inativo'
      // },
      // {
      //   text: 'Imprimir Imóveis',
      //   path: '/imprimir_imovel'
      // },

      // {
      //   text: 'Juros C',
      //   path: '/mov3'
      // }
    ],
  },
  {
    text: "Relatórios",
    icon: "doc",
    items: [
      {
        text: "Extrato de Débitos",
        path: "/extrato-debitos",
      },
      {
        text: "Notas do ADN",
        path: "/adn-nfe",
      },
      {
        text: "Encerramento Fiscal Manual",
        path: "/encerramento-fiscal",
      },
      {
        text: "Protocolos",
        path: "/protocolos",
      },
      {
        text: "Simulações",
        path: "/simulacoes",
      },
      {
        text: "Arrecadações",
        path: "/relatorio-arrecadacoes",
        visible: false,
      },
      {
        text: "Arrecadação Geral",
        path: "/arrecadacaogeral",
      },
      {
        text: "Arrecadação Receita",
        path: "/arrecadacaoreceita",
      },
      {
        text: "Arrecadação Contabilidade",
        path: "/arrecadacaocontabilidade",
      },
      {
        text: "Arquivos e Boletos",
        path: "/arquivos-e-boletos",
      },
      {
        text: "Relação de Dívida Ativa",
        path: "/relacaodividaativa",
      },
      {
        text: "Cubo de Imóveis",
        path: "/cubo_imoveis",
      },
      {
        text: "Impressão de IPTU",
        path: "/imprimiriptu",
      },
      {
        text: "Listar Processamento",
        path: "/listarprocessamentos",
      },
      {
        text: "Painel Imobiliario",
        path: "/painel-imobiliario",
      },
      {
        text: "Acompanhamento Simples Nacional",
        path: "/acompanhamento-simples-nacional",
      },
      {
        text: "Simples Declarado-Faturado",
        path: "/relatorio_fat_dec_sn",
      },
      {
        text: "Declarações Simples Nacional",
        path: "/declaracoes_sn",
      },
      {
        text: "NFS-e por CPBS",
        path: "/nfse_cpbs",
      },
      {
        text: "Espelho de CPBS da NFS-e",
        path: "/espelho_cpbs_nfse",
      },
      {
        text: "Ranking de Notas Nfse",
        path: "/ranking_nfse",
      },
      {
        text: "Escriturações Nfse",
        path: "/relacao_encerramento_nfse",
      },
      {
        text: "Relatório de Alvarás Emitidos",
        path: "/relatorio-alvaras-emitidos",
      },
    ],
  },

  {
    text: "Dívida Ativa",
    icon: "home",
    items: [
      {
        text: "Cálculo Manual de Dívida Ativa",
        path: "/calculo-divida-ativa",
      },
      {
        text: "Débitos da Dívida Ativa",
        path: "/acompanhardiat",
      },
      {
        text: "Inscrição Manual",
        path: "/inscricao-manual",
      },
      {
        text: "Notificações",
        path: "/notificacaodiat",
      },
      {
        text: "Protocolo de Notificação",
        path: "/protocolo_entrega_notificacao",
      },
      {
        text: "Acordo",
        path: "/negociacaodiat",
      },
      {
        text: "Acompanhamento de Acordos",
        path: "/conferenciaacordos",
      },
      {
        text: "CDA",
        path: "/cda",
      },
      {
        text: "(p) Devedores",
        path: "/cubo_imoveis",
        visible: false,
      },
      {
        text: "(p) Transferência",
        path: "/cubo_imoveis",
        visible: false,
      },
      {
        text: "Prescrição Anual",
        path: "/prescrever_diat",
      },
      {
        text: "Procedimento",
        path: "/procedimento-diat",
        visible:false
      },
      {
        text: "Gerar Livro",
        path: "/gerar-livro-diat",
        visible: false
      },
      {
        text: "Transferência Anual",
        path: "/transferencia-anual-diat",
      },
      {
        text: "Livros da Dívida Ativa",
        path: "/livros-diat",
      },
      {
        text: "(p) Livro",
        path: "/cubo_imoveis",
        visible: false,
      },
      { 
        text: "Fundamentos Legais", 
        path: "/fundamento_legal",
        visible: false
      },
    ],
  },
  {
    text: "Itens para organizar",
    icon: "preferences",
    visible: false,
    items: [
      {
        text: "Baixar Notas",
        path: "/baixarnotas",
        visible: false,
      },
      {
        text: "Detalhe de Lançamento",
        path: "/detalhelancamento",
        visible: false,
      },
      {
        text: "Acompanhar Processamento",
        path: "/acompanharprocessamento",
        visible: false,
      },
      {
        text: "Detalhe Nota Fiscal Avulsa",
        path: "/detalhenfavulsa",
        visible: false,
      },
    ],
  },
  {
    text: "Blazor",
    icon: "preferences",
    visible: ambiente.mfeBlazorEnabled,
    items: [
      {
        text: "Counter",
        path: "/counter",
        visible: true,
        externalMfe: "/blazor"
      }
    ],
  },
];
